<template>
<div class="pagecoinWithdraw" id="">  
  <div class="xr-mingxi">
    <mu-appbar class="xr-head" title="金币提现">
      <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
      <router-link  slot="right" to="/usercenter/myMoneyCoreTxList">
          <p>明细</p>
      </router-link>
    </mu-appbar>
  </div>
  <div class="login-form">
    <mu-row gutter class="balance-info">
      <mu-col width="100" tablet="50" desktop="33" class="div2">
        <span style="color:#999;">可用余额</span>：{{memberFinance.Coin.toFixed(2)}}元
      </mu-col>
    </mu-row>
    <mu-row gutter class="withdraw-money">
      <mu-col width="100" tablet="100" desktop="33">
        <mu-text-field label="手机号" icon=":fa fa-phone" labelFloat fullWidth :disabled="true" v-model="mobile" />
      </mu-col>
      <mu-col width="70" tablet="75" desktop="33">
        <mu-text-field label="短信验证码" helpText="点击右侧按钮获取" v-model="code" icon=":fa fa-envelope-o" labelFloat fullWidth />
      </mu-col>
      <mu-col width="30" tablet="25" desktop="33">      
        <mu-raised-button :label="smsBtnText" class="sms-button" @click="getSmsCode()" secondary/>   
      </mu-col>
    </mu-row>
    <mu-list class="account-info">
      <router-link to="/usercenter/withdrawAccount?mode=select">
      <mu-list-item :title="bankInfo.bankname" :describeText="bankInfo.bankno">
        <mu-icon :value="bankInfo.icon" style="color:#00A0E9" slot="left"/>


        <mu-icon value=":fa fa-angle-right" slot="right"/>
      </mu-list-item>
      </router-link>
    </mu-list>
    <mu-divider></mu-divider>
    <mu-row gutter class="withdraw-money">
      <mu-col width="100" tablet="100" desktop="33">
        <mu-text-field label="提现金额" helpText="提现金额必须≥100元，收取6%手续费" type="number" iconClass="withdrawMoneyText" v-model="withdrawCoin" icon=":fa fa-rmb" fullWidth />
      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col width="100" tablet="50" desktop="33" class="btn-div">
        <mu-raised-button label="确认提现" class="goWithdraw" primary fullWidth @click="open()" />
        
        <mu-popup position="bottom" popupClass="pagecoinWithdrawPayPopup" :open="PayPopup" @close="close()">
          <mu-content-block>
            <p class="title">确定提现吗？</p>
            <mu-divider></mu-divider>
            <p class="withdrawResult">提现金额{{widthdrawCoinValue.toFixed(2)}}元，手续费{{feeCoin.toFixed(2)}}元</p>
            <mu-raised-button label="提现" class="submit" primary fullWidth @click="submit()" />
          </mu-content-block>
        </mu-popup>

      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col width="100" tablet="50" desktop="33" class="div2">
        <mu-sub-header>提现需知</mu-sub-header>
        <mu-content-block class="notice">款项只能提现到实名认证的银行卡上。如您实名认证有误，请联系：{{siteConfigInfo.Phone}}或E-mail：{{siteConfigInfo.Email}}。</mu-content-block>
      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col width="100" tablet="50" desktop="33" class="div3">
        <XR-toast @onClose="GoHistory" ref="XRtoast"></XR-toast>
      </mu-col>
    </mu-row>
  </div>
</div>
</template>
<script>
import md5 from 'js-md5'
import {ErrorCode} from '../../util/errorcode'
import siteconfig from '../../util/siteconfigCache'
export default {
  data () {
    return {
      siteConfigInfo: {},
      PayPopup : false,
      withdrawCoin: '',
      memberFinance:{Coin:0},
      payPassword : '',
      isSms:false,
      bankInfo:{
        bid:0,
        bankname: '点击选择',
        bankno: '请选择账户',
        icon:':fa fa-spinner'
      },      
      mobile:'',
      smsBtnText : '获取短信',
      code:''
    }
  },
  computed: {
    widthdrawCoinValue:function(){
      return this.withdrawCoin >0 ? parseFloat(this.withdrawCoin) : 0.00
    },
    feeCoin:function(){
      return this.withdrawCoin >0 ? parseFloat(this.withdrawCoin*0.06):0.00
    }
  },
  mounted:function(){
    this.$postBase(
      this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
      ).then(function(res) {
      if(!res.IsSuccess){
          //ths.$refs.XRtoast.failed(res.Msg, true)
      }else{
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.Data.AppId, // 必填，公众号的唯一标识
              timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
              nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
              signature: res.Data.Sign, // 必填，签名，见附录1
              jsApiList: [] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
              WeixinJSBridge.call('hideOptionMenu');
          });
      }
    });
    this.siteConfigInfo = siteconfig.getSiteconfig()

    this.getMemberInfo()
    this.getFinanceInfo()

    var ths = this;
    var selectBankId = window.sessionStorage.getItem('_xr_select_bank')
    if (selectBankId>0){
      this.$post('/Shop/UserServer/GetMemberBankDetail', JSON.stringify({bankId:selectBankId}))
      .then(function (res) {
        if(res.IsSuccess){
          ths.bankInfo = res.Data
          if(ths.bankInfo.bankname=="工商银行"){
            ths.bankInfo.icon = ":fa fa-gongshang"
          }
          if(ths.bankInfo.bankname=="支付宝"){
             ths.bankInfo.icon = ":fa fa-alipay"
          }
          if(ths.bankInfo.bankname=="建设银行"){
            ths.bankInfo.icon = ":fa fa-jianshe"
          }
          if(ths.bankInfo.bankname=="中国银行"){
             ths.bankInfo.icon = ":fa fa-zhongguo"
          }
          if(ths.bankInfo.bankname=="农业银行"){
            ths.bankInfo.icon = ":fa fa-nongye"
          }
          if(ths.bankInfo.bankname=="民生银行"){
             ths.bankInfo.icon = ":fa fa-mingsheng"
          }
          if(ths.bankInfo.bankname=="交通银行"){
            ths.bankInfo.icon = ":fa fa-jiaotong"
          }
          if(ths.bankInfo.bankname=="招商银行"){
             ths.bankInfo.icon = ":fa fa-zhaoshang"
          }
          if(ths.bankInfo.bankname=="广发银行"){
            ths.bankInfo.icon = ":fa fa-guangfa"
          }
          if(ths.bankInfo.bankname=="平安银行"){
             ths.bankInfo.icon = ":fa fa-pingan"
          }
          if(ths.bankInfo.bankname=="兴业银行"){
             ths.bankInfo.icon = ":fa fa-xingye"
          }
          if(ths.bankInfo.bankname=="中国光大银行"){
            ths.bankInfo.icon = ":fa fa-guangda"
          }
          if(ths.bankInfo.bankname=="财付通"){
             ths.bankInfo.icon = ":fa fa-zhongguo"
          }

        }          
      })
      .catch(function (err) {
        console.log(err)
      })    
    }
    else {
      this.$post('/Shop/UserServer/GetMemberDefaultBank')
      .then(function (res) {
        if(res.IsSuccess){
          ths.bankInfo = res.Data
          if(ths.bankInfo.bankname=="工商银行"){
            ths.bankInfo.icon = ":fa fa-gongshang"
          }
          if(ths.bankInfo.bankname=="支付宝"){
             ths.bankInfo.icon = ":fa fa-alipay"
          }
          if(ths.bankInfo.bankname=="建设银行"){
            ths.bankInfo.icon = ":fa fa-jianshe"
          }
          if(ths.bankInfo.bankname=="中国银行"){
             ths.bankInfo.icon = ":fa fa-zhongguo"
          }
          if(ths.bankInfo.bankname=="农业银行"){
            ths.bankInfo.icon = ":fa fa-nongye"
          }
          if(ths.bankInfo.bankname=="民生银行"){
             ths.bankInfo.icon = ":fa fa-jiaotong"
          }
          if(ths.bankInfo.bankname=="交通银行"){
            ths.bankInfo.icon = ":fa fa-gongshang"
          }
          if(ths.bankInfo.bankname=="招商银行"){
             ths.bankInfo.icon = ":fa fa-zhaoshang"
          }
          if(ths.bankInfo.bankname=="广发银行"){
            ths.bankInfo.icon = ":fa fa-pingan"
          }
          if(ths.bankInfo.bankname=="平安银行"){
             ths.bankInfo.icon = ":fa fa-alipay"
          }
          if(ths.bankInfo.bankname=="兴业银行"){
             ths.bankInfo.icon = ":fa fa-xingye"
          }
          if(ths.bankInfo.bankname=="中国光大银行"){
            ths.bankInfo.icon = ":fa fa-guangda"
          }
          if(ths.bankInfo.bankname=="财付通"){
             ths.bankInfo.icon = ":fa fa-zhongguo"
          }
        }
         
      })
      .catch(function (err) {
        console.log(err)
      })    
    }
  },
  methods: {
    getMemberInfo(){  
    
      var ths = this;     
      
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.loaded =false          
          ths.$refs.XRtoast.hide()
          ths.mobile=res.Data.mobile
        }
      });      
    },
    getFinanceInfo: function() {
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetMemberFinanceAccount"
      ).then(function(res) {
        if(!res.IsSuccess){
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.memberFinance = res.Data;
        }
      });
    },
    getSmsCode: function(){
      var ths = this;   
      if(!ths.isSms){
        ths.$post(
          "/Shop/UserServer/CoinWithdrawSendSms"
        ).then(function(res) {
          ths.$refs.XRtoast.hide()
          if(!res.IsSuccess){
            ths.$refs.XRtoast.failed(res.Msg, true)
          }else{    
            ths.isSms =true      
            ths.smsBtnText = res.Data * 60;
            var interval = setInterval(function(){
              if(ths.smsBtnText >0){
                ths.smsBtnText--
                ths.isSms =true 
              }else{                
                ths.isSms =false 
                ths.smsBtnText = '获取短信'
                clearInterval(interval)
              }
            }, 1000)  
          }
        });
      }
    },
    open () {
      if(!this.withdrawCoin){
        this.$refs.XRtoast.failed('请输入提现金额',true)
        return
      }
      if(!this.code){
        this.$refs.XRtoast.failed('请输入验证码',true)
        return
      }
      if(this.bankInfo.bid<=0){
        this.$refs.XRtoast.failed('请选择提现账户',true)
        return
      }
      this.PayPopup = true
    },
    close (position) {
      this.PayPopup = false
    },

    submit: function(){
      this.close()
      var ths=this
      if(!this.code){
          ths.$refs.XRtoast.failed('请输入验证码',true)   
          return
      }
      ths.$post(
        "/Shop/UserServer/CoinWithdraw",
        JSON.stringify({code:this.code, bankId:this.bankInfo.bid,money:this.withdrawCoin})
      ).then(function(res) {
        ths.payPassword = ''
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg,true)
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.$refs.XRtoast.success(res.Msg,true)          
        }
      });
    },
    GoHistory(){
      this.$router.goBack()
    }
  }
}

</script>
<style>
.pagecoinWithdraw .login-form {
}
.pagecoinWithdraw .div3 {
  text-align: center;
  position: absolute;
  bottom: 40px;
  left: 0;
}
.pagecoinWithdraw .notice{
  font-size: 12px;
}
.pagecoinWithdraw .sms-button{
  margin-top: 28px;
  margin-bottom: 12px;
}


.pagecoinWithdraw .balance-info{
  background: white;
  line-height: 26px;
  padding: 10px;
}
.pagecoinWithdraw .account-info{
  background: white;
  margin-top: 10px;
}
.pagecoinWithdraw .withdraw-money{
  margin-top: 10px;
  background: white;
  padding: 20px 0;
}
.pagecoinWithdraw .withdraw-money .withdrawMoneyText{
  color:#f7ba47;
}
.pagecoinWithdraw .btn-div{
  text-align: center;
  padding: 20px 0;
}
.pagecoinWithdraw .btn-div .goWithdraw{
  width: 90%;
  height: 50px;
}

.pagecoinWithdrawPayPopup{
  width: 100%;
}
.pagecoinWithdrawPayPopup .title{
  font-size: 16px;
  text-align: center;
}
.pagecoinWithdrawPayPopup .withdrawResult{
  font-size: 14px;
  text-align: center;
  padding-top: 20px;
}
.pagecoinWithdrawPayPopup .submit{
  height: 50px;
}

.pagecoinWithdraw .xr-mingxi .mu-appbar.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
}
.pagecoinWithdraw .xr-mingxi .mu-appbar-title {
  font-size: 16px;
}
.pagecoinWithdraw .xr-mingxi .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.pagecoinWithdraw .xr-mingxi .title .title-text {
  margin: 0;
  line-height: 48px;
}
.pagecoinWithdraw .xr-mingxi .right{
  margin: 0 8px;
  font-size: 16px
}
.pagecoinWithdraw .xr-mingxi .right a{
  color: #fff;
}
.fa-pingan:before {
    content: "\F401";
    padding-right: 25px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/coinWithdraw.vue